<template>
	<div class="w-full">
		<div class="justify-content-center">
			<div class="w-full">
				<Toolbar class="toolbar">
					<div class="w-full h-full scroll-x scroll-transparent d-flex">
						<ul id="nav-content-level-1" class="w-full h-full nav nav-pills nav-theme justify-content-center">
							<li class="nav-item">
								<a class="nav-link pb-md-3 px-md-3" :class="{ 'active': tab === 'data' }" data-toggle="tab" href="#data" @click="tab = 'data'">Dados</a>
							</li>
							<li class="nav-item">
								<a class="nav-link pb-md-4 px-md-4" data-toggle="tab" href="#password" @click="tab = 'password'">Mudar senha</a>
							</li>
							<li class="nav-item">
								<a class="nav-link pb-md-3 px-md-3"
									:class="{ 'active': tab === 'email' }"
									data-toggle="tab"
									href="#email"
									@click="tab = 'email'"
								>
									E-mail
								</a>
							</li>
							<li class="nav-item">
								<a class="nav-link pb-md-4 px-md-4" data-toggle="tab" href="#theme" @click="tab = 'theme'">Tema</a>
							</li>
							<li class="nav-item">
								<a class="nav-link pb-md-4 px-md-4"
									:class="{ 'active': tab === 'accesses' }"
									data-toggle="tab"
									href="#accesses"
									@click="tab = 'accesses'"
								>
									Acessos
								</a>
							</li>
							<li class="nav-item">
								<a class="nav-link pb-md-3 px-md-3"
									:class="{ 'active': tab === 'subscriptions' }"
									data-toggle="tab"
									href="#subscriptions"
									@click="ResetComponent('subscriptions')"
								>
									Assinaturas
								</a>
							</li>
							<li class="nav-item">
								<a class="nav-link pb-md-3 px-md-3"
									:class="{ 'active': tab === 'payments' }"
									data-toggle="tab"
									href="#payments"
									@click="ResetComponent('payments')"
								>
									Métodos de Pagamento
								</a>
							</li>
						</ul>
					</div>
				</Toolbar>

				<div id="tab-content-level-1" class="tab-content d-flex w-full justify-content-center p-3">
					<div v-if="tab == 'data'" id="data" class="tab-pane w-full" :class="{ 'active': tab === 'data' }">
						<PersonalInfo ref="personalInfo" />
					</div>

					<div v-if="tab == 'password'" id="password" class="tab-pane w-full">
						<Password ref="password" />
					</div>

					<div v-if="tab == 'email'" id="email" class="tab-pane w-full" :class="{ 'active': tab === 'email' }">
						<Email ref="email" />
					</div>
					<div v-if="tab == 'theme'" id="theme" class="tab-pane w-full">
						<Theme />
					</div>
					<div v-if="tab == 'accesses'" id="accesses" class="tab-pane w-full" :class="{ 'active': tab === 'accesses' }">
						<Accesses />
					</div>
					<div v-if="tab == 'subscriptions'" id="subscriptions" class="tab-pane w-full" :class="{ 'active': tab === 'subscriptions' }">
						<Subscriptions 
							v-if="!is_free_plan && has_verified_email"
							ref="subscriptions"
							:content_loaded="content_subscription_loaded"
							:client_secret="client_secret"
							:price="price"
							:cards="cards"
							:subscriptions="subscriptions"
							@redirect_after="RedirectAfter"
							@refresh_subscriptions="GetSubscriptions"
							@refresh_cards="RefreshCards"
							@reset_component="ResetComponent('subscriptions')"
						/>
						<div v-else class="col-12 px-0 text-center">
							Sua conta está isenta de assinaturas.
						</div>
					</div>
					<div v-if="tab == 'payments'" id="payments" class="tab-pane w-full" :class="{ 'active': tab === 'payments' }" >
						<Payments 
							v-if="!is_free_plan && has_verified_email"
							ref="payments"
							:content_loaded="content_payment_loaded"
							:client_secret="client_secret"
							:cards="cards"
							:subscriptions="subscriptions"
							:redirect_after="redirect_after"
							:open_modal="props_tab === 'payments'"
							@refresh_cards="RefreshCards"
							@refresh_subscriptions="GetSubscriptions"
							@reset_component="ResetComponent('payments')"
						/>
						<div v-else class="w-full text-center">
							Sua conta está isenta de fornecer informações de pagamento.
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Email from './sections/Email'
	import Password from './sections/Password'
	import PersonalInfo from './sections/PersonalInfo'
	import Theme from './sections/Theme'
	import Accesses from './sections/Accesses'
	import Payments from './sections/Payments'
	import Subscriptions from './sections/Subscriptions'
	import Toolbar from '../shared/layout/ToolBar.vue'
	import Swal from 'sweetalert2'
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import moment from 'moment'

	export default {
		name: 'Others',
		components: 	{
			Email,
			Password,
			PersonalInfo,
			Theme,
			Accesses,
			Payments,
			Subscriptions,
			Toolbar
		},
		props: {
			props_tab:		{
				Type: 		String,
				default:	'accesses'
			}
		},
		data () {
			return {
				client_secret:					'',
				cards:							[],
				subscriptions:					[],
				price:							null,
				visible_tab:					this.tab,
				content_subscription_loaded: 	false,
				content_payment_loaded: 		false,
				tab:							'',
				redirect_after:					false
			}
		},
		computed: {
			...mapGetters('auth', [
				'account'
			]),
			professional_subscription() {
				return this.subscriptions.find(s => s.plan.type === 'licensed') || null
			},
			is_free_plan() {
				const is_free = !!this.subscriptions.find(s => s.plan.lookup_key === 'free')

				if(is_free) {
					const data_nav_link = window.jQuery('a[href="informacoes"]').eq(0)

					this.ResetActiveTabs(data_nav_link)

					this.tab = 'data'
				}

				return is_free;
			},
			has_verified_email() {
				return !!this.account.email_verified_at
			},
		},
		watch: {
			props_tab: {
				handler(val) {
					this.tab = val
				},
				immediate: true
			},
			tab() {
				this.EmitFooterAction()
			},
			content_subscription_loaded() {
				this.EmitFooterAction()
			},
			content_payment_loaded() {
				this.EmitFooterAction()
			},
			subscriptions: {
				handler() {
					this.EmitFooterAction()
				},
				deep: true
			},
			account: {
				handler() {
					this.EmitFooterAction()
				},
				deep: true
			},
		},
		methods: {
			...mapActions('auth', [
				'GetAuthAccount'
			]),
			...mapActions('system', [
				'StartLoading', 'FinishLoading'
			]),
			RedirectAfter(val) {
				this.redirect_after = val
			},
			UpdateCards(val) {
				this.cards = val.cards
			},
			async RefreshCards() {
				await this.GetCards()
			},
			async GetSubscriptions() {
				const vm = this

				vm.content_subscription_loaded = false

				return await window.api.call('get', '/gateway/get-subscriptions')
					.then(async ({data}) => {
						if(data.response) {
							vm.subscriptions 					= [ ...data.subscriptions ]
						} else {
							vm.subscriptions 					= []

							await vm.GetAuthAccount();
						}
					})
					.finally(() => {
						vm.content_subscription_loaded = true
					})
			},
			async GetCards() {
				const vm = this;

				vm.content_payment_loaded = false;

				vm.StartLoading();

				window.jQuery('.InputElement').each(function (el) {
					window.jQuery(el).value = null;
				})

				return await window.api.call('get', '/gateway/get-cards')
					.then(({data}) => {
						if(data.response) {
							vm.client_secret 	= data.client_secret

							if(data.cards.length) {
								vm.cards = _.orderBy(data.cards.map((c, i) => {
									const exp_date = `${c.exp_month}/${c.exp_year}`
									const now = moment()
									
									return {
										...c,
										exp_date,
										is_or_expiring: moment(exp_date, 'MM/YYYY').isBefore(now)
									}
								}), 'id')
							} else {
								vm.cards = []
							}
							
							vm.price			= data.price

							return
						}
					})
					.finally(() => {
						vm.FinishLoading()
						
						vm.content_payment_loaded = true
					})
			},
			ResetComponent(type) {
				this.tab = type

				switch(type) {
					case 'payments': 
						this.content_payment_loaded = !this.content_payment_loaded

						this.$nextTick(() => {
							this.content_payment_loaded = !this.content_payment_loaded
						});
					break;
					case 'subscriptions':
						this.content_subscription_loaded = !this.content_subscription_loaded

						this.$nextTick(() => {
							this.content_subscription_loaded = !this.content_subscription_loaded
						});
					break;
				}

				this.$nextTick(() => {
					this.EmitFooterAction()
				})
			},
			ResetActiveTabs(active_link) {
				const tab_pane_id = active_link.attr('href')
				
				window.jQuery(`#nav-content-level-1 .nav-item > a.nav-link`).not(active_link).each(function () {
					window.jQuery(this).removeClass('active');
				})

				window.jQuery(`#tab-content-level-1 > .tab-pane:not(${tab_pane_id})`).each(function () {
					window.jQuery(this).removeClass('active');
				})
			},
			GetFooterAction() {
				if (this.tab === 'data') {
					return { visible: true, label: 'SALVAR', disabled: false }
				}

				if (this.tab === 'password') {
					return { visible: true, label: 'SALVAR', disabled: false }
				}

				if (this.tab === 'email') {
					return { visible: true, label: 'ENVIAR', disabled: false }
				}

				if (this.tab === 'subscriptions') {
					const canShow = !this.is_free_plan && this.has_verified_email && !this.professional_subscription

					return {
						visible: canShow,
						label: 'FINALIZAR',
						disabled: !this.content_subscription_loaded,
					}
				}

				if (this.tab === 'payments') {
					const canShow = !this.is_free_plan && this.has_verified_email

					return {
						visible: canShow,
						label: 'ADICIONAR',
						disabled: !this.content_payment_loaded,
					}
				}

				return { visible: false, label: '', disabled: false }
			},
			EmitFooterAction() {
				this.$emit('footer-action-change', this.GetFooterAction())
			},
			TriggerFooterAction() {
				switch(this.tab) {
					case 'data':
						if (this.$refs.personalInfo && this.$refs.personalInfo.SavePersonalInfo) {
							this.$refs.personalInfo.SavePersonalInfo()
						}
					break;
					case 'password':
						if (this.$refs.password && this.$refs.password.Save) {
							this.$refs.password.Save()
						}
					break;
					case 'email':
						if (this.$refs.email && this.$refs.email.Send) {
							this.$refs.email.Send()
						}
					break;
					case 'subscriptions':
						if (this.$refs.subscriptions && this.$refs.subscriptions.TriggerFooterAction) {
							this.$refs.subscriptions.TriggerFooterAction()
						}
					break;
					case 'payments':
						if (this.$refs.payments && this.$refs.payments.TriggerFooterAction) {
							this.$refs.payments.TriggerFooterAction()
						}
					break;
				}
			},
		},
		async mounted() {
			const vm = this

			window.jQuery('.nav-item').click(function () {
				const link = window.jQuery(this).find('a.nav-link').eq(0)

				vm.ResetActiveTabs(link)
			})

			if(vm.account.email && vm.account.email_verified_at) {
				await vm.GetCards()
	
				await vm.GetSubscriptions()
				vm.EmitFooterAction()
			} else {
				Swal.fire({
					title: 				'Ops!',
					text: 				'Autentique o seu e-mail para continuar!',
					icon: 				'info',
					confirmButtonText: 	'Ok',
					backdrop:           false,
					preConfirm: () => {
						window.jQuery('a[href="#email"]').tab('show')
					}
				})

				return false;
			}

			vm.EmitFooterAction()
		}

	}
</script>

<style lang="css" scoped>
.grid-layout .toolbar {
	height: 2.9rem;
    padding: 0rem 1rem 0;
    margin-bottom: 0.75rem;
}

#nav-content-level-1 {
	flex-wrap: nowrap;
	box-sizing: unset;
}

#nav-content-level-1 .nav-item {
	margin-bottom: -1px;
}

#nav-content-level-1 .nav-link {
	border: 0;
	border-bottom: 2px solid transparent;
	border-radius: 0;
	background: transparent !important;
	padding: 0.85rem 1rem;
	font-size: 0.75rem;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--newPrimaryBackgroundColor);
	height: 2.813rem;
}

#nav-content-level-1 .nav-link:hover,
#nav-content-level-1 .nav-link:focus {
	border-bottom-color: var(--newPrimaryColor);
	color: rgba(214, 224, 255, 0.92);
}

#nav-content-level-1 .nav-link.active {
	background: transparent !important;
	color: var(--newPrimaryColor);
	border-bottom-color: var(--newPrimaryColor);
}

a:hover,
.link:hover {
	color: var(--newPrimaryHoverColor) !important;
}

.nav.nav-pills.nav-theme .nav-link {
	opacity: unset;
}

#subscriptions {
	min-height: 50px;
	max-height: 700px;
	overflow: auto;
}
</style>